package com.trevorwiebe.timesheet.loads.presentation.driver

// The Google Maps web URL has no labeled-pin form, so the browser searches the coordinates
// (or the name/address text when there's no pin).
internal actual fun mapsUrlFor(link: MapsLink): String =
    "https://www.google.com/maps/search/?api=1&query=${link.latLng ?: link.encodedQuery}"
